import round from 'lodash/round';
import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorAccentLinkLight, colorBrandYamahaGrey, colorCoreBackground1000, colorCoreBlack300, colorCoreBlack900Base, hexColorBlackTransparent50, } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
const getCellTextAlign = (isFirst, isRightToLeft, isUnfreezeFirstColumn) => {
    if (isFirst || isUnfreezeFirstColumn) {
        return isRightToLeft ? 'right' : 'left';
    }
    return isRightToLeft ? 'left' : 'right';
};
const cellStyles = css `
  margin: 0;
  padding: 10px 16px;
  text-align: ${({ isFirst, isRightToLeft, isUnfreezeFirstColumn }) => getCellTextAlign(isFirst, isRightToLeft, isUnfreezeFirstColumn)};
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-width: 100px;
  max-width: 300px;

  ${({ isUnfreezeFirstColumn, countCells }) => isUnfreezeFirstColumn && `width: ${round(100 / countCells, 2)}%;`}

  p {
    margin: 0;
  }

  a {
    color: ${colorAccentLinkLight};
  }

  &:first-of-type {
    ${({ isUnfreezeFirstColumn }) => !isUnfreezeFirstColumn &&
    css `
        position: sticky;
        left: 0;
        width: 100px;
        z-index: ${Z_INDEX.level1};

        ${({ isRightToLeft }) => isRightToLeft
        ? `border-left: 1px solid ${colorBrandYamahaGrey};`
        : `border-right: 1px solid ${colorBrandYamahaGrey};`};
      `}
  }

  &:last-child {
    ${({ hasScroll, isRightToLeft }) => hasScroll && (isRightToLeft ? 'padding-left: 36px;' : 'padding-right: 36px;')};
  }
`;
export const DataTableWrapper = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${CustomScroll}
`;
export const DataTableStyled = styled.table `
  box-sizing: border-box;
  border-spacing: 0;
  border: 0;
  padding-bottom: 8px;
  min-width: 100%;
  width: 100%;
`;
export const TableCellStyled = styled.td `
  ${cellStyles};

  ${({ customStyles }) => customStyles};

  &:first-child {
    background-color: ${({ isOdd }) => isOdd ? `${colorCoreBackground1000}` : `${hexColorBlackTransparent50}`};
  }
`;
export const TableCellHeadStyled = styled.th `
  ${cellStyles};

  ${({ customStyles }) => customStyles};

  &:first-child {
    background-color: ${hexColorBlackTransparent50};
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`;
export const TableRowStyled = styled.tr `
  ${getTextStyles('Ubuntu', null, 16, 24)}

  ${({ isHead }) => isHead && 'font-weight: 500'};

  background-color: ${({ isHead }) => isHead ? `${hexColorBlackTransparent50}` : `${colorCoreBackground1000}`};
  color: ${({ isHead }) => (isHead ? `${colorCoreBlack900Base}` : `${colorCoreBlack300}`)};

  width: 100%;

  &:nth-child(even) {
    td {
      background-color: ${hexColorBlackTransparent50};

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
`;
